import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Grid } from "@mui/material";

import CustomDataGrid from "./components/CustomDataGrid";
import usePppProfile from "../../../hooks/usePppProfile";
import { useDialog } from "../../../contexts/DialogContext";
import { getTimeStamp } from "../../../utils/common";
import Upload from "./components/Upload";

function DataGridPage() {
  const { getAllPppProfile, pppProfiles, paging, isLoading, downloadFile } = usePppProfile();

  const { totalNumberOfRecords, hasNextPage, pageNumber, pageSize } = paging;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { openDialog } = useDialog();

  const [filterResetFunc, setFilterResetFunc] = useState(
    () => () => console.log("Refresh initialized"),
  );

  const currentPayload = {
    filters: [],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [
      {
        field: "pppProfileId",
        sort: "ASC",
      },
    ],
  };

  const [sortModel, setSortModel] = useState([
    {
      field: "updatedAt",
      sort: "desc",
    },
  ]);

  const [payload, setPayload] = useState(currentPayload);

  const fetchData = async () => {
    await getAllPppProfile(payload);
  };

  const refreshPage = () => {
    setPayload(currentPayload);
    filterResetFunc();
    setPaginationModel({
      page: 0,
      pageSize: 100,
    });
  };

  const onPageChange = (newPaginationModel) => {
    console.log(newPaginationModel, "pagepage");

    const pagination = {
      pageNumber: newPaginationModel.page === 0 ? 1 : newPaginationModel.page + 1,
      pageSize: newPaginationModel.pageSize, // Update pageSize dynamically
    };

    setPayload((prev) => ({ ...prev, pagination }));
    setPaginationModel(newPaginationModel);
  };

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 100,
  });

  const paginationMetaRef = useRef();

  // Memoize to avoid flickering when the `hasNextPage` is `undefined` during refetch
  const paginationMeta = React.useMemo(() => {
    if (hasNextPage !== undefined && paginationMetaRef.current?.hasNextPage !== hasNextPage) {
      paginationMetaRef.current = { hasNextPage };
    }
    return paginationMetaRef.current;
  }, [hasNextPage]);

  const isInitialMount = useRef(true);
  useEffect(() => {
    fetchData();
  }, [payload]);

  const exportFile = async (fileType) => {
    await downloadFile(fileType, payload);
  };
  const openDownloadDialog = () => {
    return openDialog("upload_ppp_profile", "Upload PppProfile", <Upload key={getTimeStamp()} />);
  };

  const handleSortModelChange = (newModel) => {
    console.log(newModel, "newModel");
    if (newModel.length !== 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };

  const addPppProfile = () => {
    navigate("/mikrotik-mgnt/ppp-profile/add");
  };
  const editPppProfile = (id) => {
    console.log(id);
    navigate("/mikrotik-mgnt/ppp-profile/edit", { state: { id: id } });
  };

  return (
    <React.Fragment>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <CustomDataGrid
            trans={t}
            addPage={addPppProfile}
            editPage={editPppProfile}
            refreshPage={refreshPage}
            downloadFile={exportFile}
            setFilterResetFunc={setFilterResetFunc}
            openDownloadDialog={openDownloadDialog}
            id="pppProfileId"
            isLoading={isLoading}
            sortModel={sortModel}
            handleSortModelChange={handleSortModelChange}
            payload={payload}
            setPayload={setPayload}
            rows={pppProfiles}
            rowCount={totalNumberOfRecords}
            onPaginationModelChange={onPageChange}
            paginationMeta={paginationMeta}
            paging={{
              pageNumber: pageNumber,
              pageSize: pageSize,
            }}
            paginationModel={paginationModel}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default DataGridPage;
